import getTitle from 'helpers/getTitle'
import Translate from 'modules/local/Translate'
import React from 'react'
import {NullAsDefault, renderIf} from 'views/Shared'
import classNames from "classnames";
import {ItemInformation} from 'components/common/ItemInformation'
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {formatDate} from "../../../../helpers/datetimeHelpers";

export const renderCourseClassStudentSubjectSummary = ({translate: t, renderActions = NullAsDefault, registered_subjects = []} = {}) => (item, index) => {

    const {notes, subject, total_sessions, number_of_sessions, result_status, result_date} = item ?? {}
    const {description} = subject ?? {}

    const checkSubject = (id) => {
        let subject = registered_subjects.find((subject) => subject.id === id);
        return !!subject;
    };

    const isRegisterSubject = checkSubject(subject.id)

    let label_status
    let color_status
    switch (result_status) {
        case 1:
            label_status = 'passed'
            color_status = 'text-green-700'
            break
        case 0:
            label_status = 'failed'
            color_status = 'text-red-600'
            break
        case -1:
            label_status = 'pending'
            color_status = 'text-color-300'
            break
        default:
            label_status = 'evaluate'
            color_status = 'text-color-300'
            break
    }

    return (
        <LayoutContext.Consumer>
            {({isSm}) => (
                <div
                    key={index}
                    style={{opacity: isRegisterSubject ? 1 : 0.5}}
                    className={classNames(
                        "p-3 flex flex-col gap-1 border border-color-50 rounded-xl relative",
                        isRegisterSubject ? 'hover:border-color-100 hover:shadow-md cursor-pointer' : 'opacity-50'
                    )}>
                    <div className={classNames("font-semibold text-sm", isRegisterSubject ? 'text-color-000' : 'text-color-300')}>
                        {getTitle(subject)}
                    </div>
                    {renderIf(
                        !!!isRegisterSubject,
                        <div
                            className="flex italic text-color-200">{t('this subject has not been registered')}</div>
                    )}
                    <div className="flex items-center gap-x-3 md:gap-x-6 leading-tight">
                        <ItemInformation
                            showIcon={true}
                            label={isSm ? 'number sessions' : 'number of completed class sessions'}
                            value={`${total_sessions}/${number_of_sessions}`}
                            className="text-xs italic"
                        />
                        {renderIf(
                            result_date,
                            <ItemInformation
                                showIcon={true}
                                colon={!isSm}
                                label={!isSm && "result date"}
                                value={formatDate(result_date, 'DD/MM/YYYY')}
                                className="text-xs italic"
                            />
                        )}
                    </div>
                    {renderIf(
                        notes,
                        <span className="space-x-1 text-xs italic">
                                    <span className="font-bold text-color-100">{`* ${t('note')} : `}</span>
                                    <span className="text-color-300">{notes}</span>
                                </span>
                    )}
                    {renderIf(
                        isRegisterSubject,
                        <div className="absolute bottom-8 right-8">
                            {renderActions(item)}
                        </div>
                    )}
                </div>
            )}
        </LayoutContext.Consumer>
    )
}
